import { removeDataAnalyticsAttrOnBodyTag } from '../removeDataAnalyticsAttrOnBodyTag/removeDataAnalyticsAttrOnBodyTag.esm.js';

var setDataAnalyticsAttrOnBodyTag = function (page) {
    var _a, _b, _c, _d;
    var analyticsPageType = (_d = (_c = (_b = (_a = page === null || page === void 0 ? void 0 : page.fields) === null || _a === void 0 ? void 0 : _a.collection) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.audience) === null || _d === void 0 ? void 0 : _d.join(',');
    if (!analyticsPageType || analyticsPageType.length === 0) {
        removeDataAnalyticsAttrOnBodyTag();
        return;
    }
    document.body.setAttribute('data-analytics-page-type', analyticsPageType);
};

export { setDataAnalyticsAttrOnBodyTag };
//# sourceMappingURL=setDataAnalyticsAttrOnBodyTag.esm.js.map
